module.exports = __webpack_public_path__ + "img/target_eye.100f5746.png";